import { useTranslation } from 'react-i18next'
import { useCurrentUser } from '../auth/useCurrentUser'
import { useStopImpersonation } from '../../features/administration/impersonation/useStopImpersonation'

export function ImpersonationBanner() {
  const { t } = useTranslation('administration')
  const { data: user } = useCurrentUser()
  const stop = useStopImpersonation()

  if (!user || user.impersonating === null) return null

  return (
    <div
      role="alert"
      className="impersonation-banner"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: '#c0392b',
        color: 'white',
        padding: '8px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <span>
        {t('impersonation.banner.acting')}{' '}
        <strong>{user.displayName}</strong> ({user.email}).{' '}
        {t('impersonation.banner.staff')}{' '}
        <code>{user.impersonating}</code>.
      </span>
      <button
        type="button"
        onClick={() => stop.mutate()}
        disabled={stop.isPending}
        style={{ background: 'white', color: '#c0392b', border: 'none', padding: '6px 12px', cursor: 'pointer' }}
      >
        {stop.isPending
          ? t('impersonation.banner.stopping')
          : t('impersonation.banner.stop')}
      </button>
    </div>
  )
}
